<template>
  <div>
    <v-row>
      <v-col cols="4" v-for="(card) in cards" :key="card.id">
        <div
            class="fill-height px-3 py-5 card-hover"
            style="border-radius: 15px; transition: background-color, border 0.2s ease"
            :class="!card.selected ? 'unselected' : 'selected'"
            @click="selectCard(card)"
            v-ripple
        >
          <div class="text-center">{{ card.text }}</div>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "ProfileSelector",
  props: {
    cards: {
      type: Array
    }
  },

  methods: {
    selectCard(card) {
      this.$emit('select', card);
    },
  },
}
</script>

<style scoped>

.selected {
  background-color: #3377BF;
  border: 2px solid rgba(255,255,255,1);
}

.unselected {
  background-color: rgba(255, 255, 255, 0.05);
  border: 2px solid rgba(255,255,255,0.5);
}

.card-hover:hover{
  cursor: pointer;
}

</style>